import LayoutHome from '@/views/layout/index'

const routes = [{
  path: '/modules',
  redirect: '/modules/home',
  component: LayoutHome,
  children: [{
    path: 'index',
    redirect: '/index',
    meta: {
      title: '首页'
    }
  }, {
    path: 'home',
    redirect: '/modules/home/policy',
    component: () => import('@/views/modules/home/index'),
    meta: {
      title: '首页'
    },
    children: [{
      path: 'policy',
      redirect: '/modules/home/policy/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '政策法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/home/policy/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/home/policy/detail'),
        meta: {
          title: '政策法规详情',
          sidebar: false
        }
      }]
    }, {
      path: 'service',
      redirect: '/modules/home/service/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '惠企服务'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/home/service/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/home/service/detail'),
        meta: {
          title: '惠企服务详情',
          sidebar: false
        }
      }]
    }, {
      path: 'work',
      redirect: '/modules/home/work/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '工作动态'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/home/work/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/home/work/detail'),
        meta: {
          title: '工作动态详情',
          sidebar: false
        }
      }]
    },
    // {
    //   path: 'discounts',
    //   redirect: '/modules/home/discounts/index',
    //   component: () => import('@/views/modules/components/MRouterview'),
    //   meta: {
    //     title: '平台优惠'
    //   },
    //   children: [{
    //     path: 'index',
    //     component: () => import('@/views/modules/home/discounts/list'),
    //     meta: {
    //       sidebar: true
    //     }
    //   }, {
    //     path: 'detail',
    //     component: () => import('@/views/modules/home/discounts/detail'),
    //     meta: {
    //       title: '平台优惠详情',
    //       sidebar: false
    //     }
    //   }]
    // }, 
    {
      path: 'nqi',
      redirect: '/modules/home/nqi/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: 'NQI政务服务'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/home/nqi/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/home/nqi/detail'),
        meta: {
          title: 'NQI政务服务详情',
          sidebar: false
        }
      }]
    },
    // {
    //   path: 'station',
    //   redirect: '/modules/home/station/index',
    //   component: () => import('@/views/modules/components/MRouterview'),
    //   meta: {
    //     title: '质量服务站'
    //   },
    //   children: [{
    //     path: 'index',
    //     component: () => import('@/views/modules/home/station/index'),
    //     meta: {
    //       sidebar: true
    //     }
    //   }]
    // }, 
    {
      path: 'news',
      redirect: '/modules/home/news/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '新闻动态'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/home/news/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/home/news/detail'),
        meta: {
          title: '新闻动态详情',
          sidebar: false
        }
      }]
    }, {
      path: 'affiche',
      redirect: '/modules/home/affiche/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '召回公告'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/home/affiche/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/home/affiche/detail'),
        meta: {
          title: '召回公告详情',
          sidebar: false
        }
      }]
    }, {
      path: 'safety',
      redirect: '/modules/home/safety/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '安全教育'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/home/safety/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/home/safety/detail'),
        meta: {
          title: '安全教育详情',
          sidebar: false
        }
      }]
    }, {
      path: 'law',
      redirect: '/modules/home/law/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '法律法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/home/law/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/home/law/detail'),
        meta: {
          title: '安全教育详情',
          sidebar: false
        }
      }]
    }]
  }, {
    path: 'service',
    redirect: '/modules/service/organization',
    component: () => import('@/views/modules/service/index'),
    meta: {
      title: '标准服务'
    },
    children: [{
      path: 'organization',
      redirect: '/modules/service/organization/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务机构'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/service/organization/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/service/organization/detail'),
        meta: {
          title: '服务机构详情',
          sidebar: true
        }
      }]
    }, {
      path: 'expert',
      component: () => import('@/views/modules/service/expert/list'),
      meta: {
        title: '服务专家',
        sidebar: true
      }
    }, {
      path: 'project',
      redirect: '/modules/service/project/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务内容'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/service/project/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/service/project/detail'),
        meta: {
          title: '服务内容详情',
          sidebar: true
        }
      }]
    }, {
      path: 'policy',
      redirect: '/modules/service/policy/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '政策法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/service/policy/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/service/policy/detail'),
        meta: {
          title: '政策法规详情',
          sidebar: false
        }
      }]
    },
      // {
      //   path: 'knowledge',
      //   component: () => import('@/views/modules/service/knowledge/index'),
      //   meta: {
      //     title: '标准知识服务',
      //     sidebar: true
      //   }
      // }
    ]
  }, {
    path: 'detection',
    redirect: '/modules/detection/organization',
    component: () => import('@/views/modules/detection/index'),
    meta: {
      title: '检验检测'
    },
    children: [{
      path: 'organization',
      redirect: '/modules/detection/organization/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务机构'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/detection/organization/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/detection/organization/detail'),
        meta: {
          title: '服务机构详情',
          sidebar: true
        }
      }]
    }, {
      path: 'expert',
      component: () => import('@/views/modules/detection/expert/list'),
      meta: {
        title: '服务专家',
        sidebar: true
      }
    }, {
      path: 'project',
      redirect: '/modules/detection/project/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务内容'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/detection/project/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/detection/project/detail'),
        meta: {
          title: '服务内容详情',
          sidebar: true
        }
      }]
    },
    // {
    //   path: 'facility',
    //   component: () => import('@/views/modules/detection/facility/index'),
    //   meta: {
    //     title: '设备共享',
    //     sidebar: true
    //   }
    // }, 
    {
      path: 'policy',
      redirect: '/modules/detection/policy/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '政策法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/detection/policy/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/detection/policy/detail'),
        meta: {
          title: '政策法规详情',
          sidebar: false
        }
      }]
    }
    ]
  }, {
    path: 'metering',
    redirect: '/modules/metering/organization',
    component: () => import('@/views/modules/metering/index'),
    meta: {
      title: '计量服务'
    },
    children: [{
      path: 'organization',
      redirect: '/modules/metering/organization/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务机构'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/metering/organization/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/metering/organization/detail'),
        meta: {
          title: '服务机构详情',
          sidebar: true
        }
      }]
    }, {
      path: 'expert',
      component: () => import('@/views/modules/metering/expert/list'),
      meta: {
        title: '服务专家',
        sidebar: true
      }
    }, {
      path: 'project',
      redirect: '/modules/metering/project/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务内容'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/metering/project/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/metering/project/detail'),
        meta: {
          title: '服务内容详情',
          sidebar: true
        }
      }]
    }, {
      path: 'policy',
      redirect: '/modules/metering/policy/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '政策法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/metering/policy/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/metering/policy/detail'),
        meta: {
          title: '政策法规详情',
          sidebar: false
        }
      }]
    }]
  }, {
    path: 'equipment',
    redirect: '/modules/equipment/organization',
    component: () => import('@/views/modules/equipment/index'),
    meta: {
      title: '特种设备'
    },
    children: [{
      path: 'organization',
      redirect: '/modules/equipment/organization/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务机构'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/equipment/organization/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/equipment/organization/detail'),
        meta: {
          title: '服务机构详情',
          sidebar: true
        }
      }]
    }, {
      path: 'expert',
      component: () => import('@/views/modules/equipment/expert/list'),
      meta: {
        title: '服务专家',
        sidebar: true
      }
    }, {
      path: 'project',
      redirect: '/modules/equipment/project/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务内容'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/equipment/project/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/equipment/project/detail'),
        meta: {
          title: '服务内容详情',
          sidebar: true
        }
      }]
    }, {
      path: 'policy',
      redirect: '/modules/equipment/policy/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '政策法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/equipment/policy/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/equipment/policy/detail'),
        meta: {
          title: '政策法规详情',
          sidebar: false
        }
      }]
    }]
  }, {
    path: 'authentication',
    redirect: '/modules/authentication/organization',
    component: () => import('@/views/modules/authentication/index'),
    meta: {
      title: '认证认可'
    },
    children: [{
      path: 'organization',
      redirect: '/modules/authentication/organization/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务机构'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/authentication/organization/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/authentication/organization/detail'),
        meta: {
          title: '服务机构详情',
          sidebar: true
        }
      }]
    }, {
      path: 'expert',
      component: () => import('@/views/modules/authentication/expert/list'),
      meta: {
        title: '服务专家',
        sidebar: true
      }
    }, {
      path: 'project',
      redirect: '/modules/authentication/project/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务内容'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/authentication/project/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/authentication/project/detail'),
        meta: {
          title: '服务内容详情',
          sidebar: true
        }
      }]
    }, {
      path: 'policy',
      redirect: '/modules/authentication/policy/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '政策法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/authentication/policy/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/authentication/policy/detail'),
        meta: {
          title: '政策法规详情',
          sidebar: false
        }
      }]
    }]
  }, {
    path: 'brand',
    redirect: '/modules/brand/enterprise',
    component: () => import('@/views/modules/brand/index'),
    meta: {
      title: '品牌建设'
    },
    children: [{
      path: 'enterprise',
      component: () => import('@/views/modules/brand/enterprise/list'),
      meta: {
        title: '优秀企业',
        sidebar: true
      }
    }, {
      path: 'awards',
      redirect: '/modules/brand/awards/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '奖项指引'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/brand/awards/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/brand/awards/detail'),
        meta: {
          title: '奖项指引详情',
          sidebar: false
        }
      }]
    }, {
      path: 'specialty',
      component: () => import('@/views/modules/brand/specialty/list'),
      meta: {
        title: '地理标志',
        sidebar: true
      }
    }, {
      path: 'organization',
      redirect: '/modules/brand/organization/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务机构'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/brand/organization/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/brand/organization/detail'),
        meta: {
          title: '服务机构详情',
          sidebar: true
        }
      }]
    }, {
      path: 'expert',
      component: () => import('@/views/modules/brand/expert/list'),
      meta: {
        title: '服务专家',
        sidebar: true
      }
    }, {
      path: 'project',
      redirect: '/modules/brand/project/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务内容'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/brand/project/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/brand/project/detail'),
        meta: {
          title: '服务内容详情',
          sidebar: true
        }
      }]
    }, {
      path: 'policy',
      redirect: '/modules/brand/policy/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '政策法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/brand/policy/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/brand/policy/detail'),
        meta: {
          title: '政策法规详情',
          sidebar: false
        }
      }]
    }]
  }, {
    path: 'property',
    redirect: '/modules/property/organization',
    component: () => import('@/views/modules/property/index'),
    meta: {
      title: '知识产权'
    },
    children: [{
      path: 'organization',
      redirect: '/modules/property/organization/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务机构'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/property/organization/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/property/organization/detail'),
        meta: {
          title: '服务机构详情',
          sidebar: true
        }
      }]
    }, {
      path: 'expert',
      component: () => import('@/views/modules/property/expert/list'),
      meta: {
        title: '服务专家',
        sidebar: true
      }
    }, {
      path: 'project',
      redirect: '/modules/property/project/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务内容'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/property/project/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/property/project/detail'),
        meta: {
          title: '服务内容详情',
          sidebar: true
        }
      }]
    }, {
      path: 'policy',
      redirect: '/modules/property/policy/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '政策法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/property/policy/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/property/policy/detail'),
        meta: {
          title: '政策法规详情',
          sidebar: false
        }
      }]
    }]
  }, {
    path: 'quality',
    redirect: '/modules/quality/classroom',
    component: () => import('@/views/modules/quality/index'),
    meta: {
      title: '质量提升'
    },
    children: [{
      path: 'classroom',
      redirect: '/modules/quality/classroom/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '知识课堂'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/quality/classroom/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/quality/classroom/detail'),
        meta: {
          title: '知识课堂详情',
          sidebar: true
        }
      }]
    }, {
      path: 'train',
      redirect: '/modules/quality/train/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '培训动态'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/quality/train/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/quality/train/detail'),
        meta: {
          title: '培训动态详情',
          sidebar: true
        }
      }]
    }, {
      path: 'organization',
      redirect: '/modules/quality/organization/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务机构'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/quality/organization/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/quality/organization/detail'),
        meta: {
          title: '服务机构详情',
          sidebar: true
        }
      }]
    }, {
      path: 'expert',
      component: () => import('@/views/modules/quality/expert/list'),
      meta: {
        title: '服务专家',
        sidebar: true
      }
    }, {
      path: 'project',
      redirect: '/modules/quality/project/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务内容'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/quality/project/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/quality/project/detail'),
        meta: {
          title: '服务内容详情',
          sidebar: true
        }
      }]
    }, {
      path: 'policy',
      redirect: '/modules/quality/policy/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '政策法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/quality/policy/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/quality/policy/detail'),
        meta: {
          title: '政策法规详情',
          sidebar: false
        }
      }]
    }]
  }, {
    path: 'construction',
    redirect: '/modules/construction/organization',
    component: () => import('@/views/modules/construction/index'),
    meta: {
      title: '体系建设'
    },
    children: [{
      path: 'organization',
      redirect: '/modules/construction/organization/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务机构'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/construction/organization/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/construction/organization/detail'),
        meta: {
          title: '服务机构详情',
          sidebar: true
        }
      }]
    }, {
      path: 'expert',
      component: () => import('@/views/modules/construction/expert/list'),
      meta: {
        title: '服务专家',
        sidebar: true
      }
    }, {
      path: 'project',
      redirect: '/modules/construction/project/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '服务内容'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/construction/project/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/construction/project/detail'),
        meta: {
          title: '服务内容详情',
          sidebar: true
        }
      }]
    }, {
      path: 'policy',
      redirect: '/modules/construction/policy/index',
      component: () => import('@/views/modules/components/MRouterview'),
      meta: {
        title: '政策法规'
      },
      children: [{
        path: 'index',
        component: () => import('@/views/modules/construction/policy/list'),
        meta: {
          sidebar: true
        }
      }, {
        path: 'detail',
        component: () => import('@/views/modules/construction/policy/detail'),
        meta: {
          title: '政策法规详情',
          sidebar: false
        }
      }]
    }]
  }, {
    path: 'inquiry',
    redirect: '/modules/inquiry/expert',
    component: () => import('@/views/modules/inquiry/index'),
    meta: {
      title: '质量问诊'
    },
    children: [{
      path: 'expert',
      component: () => import('@/views/modules/inquiry/expert/list'),
      meta: {
        title: '服务专家',
        sidebar: true
      }
    }]
  }, {
    path: 'facility',
    redirect: '/modules/facility/facility',
    component: () => import('@/views/modules/facility/index'),
    meta: {
      title: '设备共享'
    },
    children: [{
      path: 'facility',
      component: () => import('@/views/modules/facility/facility/list'),
      meta: {
        title: '设备共享',
        sidebar: true
      }
    }]
  }]
}, { // 在线客服
  path: '/modules/online-service',
  component: () => import('@/views/modules/online-service/index'),
  meta: {
    title: '在线客服'
  }
}]

export default routes
